module.exports = __webpack_public_path__ + "fonts/sourcesanspro-semibold-webfont.bad97564.woff2";